import { render } from "./DocumentStatuses.vue?vue&type=template&id=81d53aa6&scoped=true"
import script from "./DocumentStatuses.vue?vue&type=script&lang=js"
export * from "./DocumentStatuses.vue?vue&type=script&lang=js"

import "./DocumentStatuses.vue?vue&type=style&index=0&id=81d53aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d53aa6"]])

export default __exports__